import device from 'bits/device'
import { $ } from 'bits/jquery'
import { isUrl } from 'bits/url'

// TODO: Remove Jquery dependency
// TODO: This mixin should be connected to trix editor, not its parent component
export default {
  beforeMount() {
    // Move the editor to the body to allow us to control its positioning
    const toolbarClass = this.floatingToolbar ? 'toolbar-floating' : 'toolbar-fixed'
    const appendTo = document.body
    this.toolbarElement = $(`<trix-toolbar class="${toolbarClass}" id="${this.toolbarId}"></trix-toolbar>`).appendTo(
      appendTo,
    )
  },
  mounted() {
    var toolbarElement = this.toolbarElement
    this.editorElement = this.$refs.editor.$refs.editor
    var $input = toolbarElement.find('input')

    toolbarElement.on('click', function(e) {
      e.stopPropagation()
    })

    // Doing this in defer because some browsers don't have the toolbar fully developed at this point.

    setTimeout(() => {
      this.addCustomButtonsToToolbar()
      var $backButton
      $backButton = $(
        '<button class="trix-back-button icon-button immaterial-icons" title="Back to formatting menu">arrow_back</button>',
      ).prependTo(toolbarElement.find('.trix-dialog__link-fields'))
      $backButton.on('click', () => {
        var linkButtonElement, mousedownEvent
        linkButtonElement = toolbarElement.find('[data-trix-action=link]')[0]
        mousedownEvent = new CustomEvent('mousedown', { bubbles: true, cancelable: true })
        linkButtonElement.dispatchEvent(mousedownEvent)
      })
    }, 0)

    // When the url form is open, detect text selection. If the selection is a url, prefill that in the url form
    $input.on('focus', () => {
      var editor = this.editorElement.editor
      var currentSelection, currentText, textWeAreInterestedIn, tryUrl
      this.toolbarInputFocused = true
      if (!this.value) {
        currentText = editor.getDocument().toString()
        currentSelection = editor.getSelectedRange()
        textWeAreInterestedIn = currentText.substring(currentSelection[0], currentSelection[1])
        if (isUrl(textWeAreInterestedIn)) {
          this.value = textWeAreInterestedIn
        } else {
          tryUrl = 'http://' + textWeAreInterestedIn
          if (isUrl(tryUrl)) {
            this.value = tryUrl
          }
        }
      }
    })

    $input.on('blur', () => {
      this.toolbarInputFocused = false
    })

    // If the url is invalid, check if adding a http:// before the url will make it valid. If it will, then do that,
    // else notify that the url is invalid.
    $input.on('invalid', e => {
      var newValue, oldValue
      oldValue = this.value || e.target.value
      if (oldValue.indexOf('http://') === 0 || oldValue.indexOf('https://') === 0) {
        // reasonably well formed url
        alert(this.invalidUrlMessage)
      } else {
        newValue = 'http://' + oldValue
        if (isUrl(newValue)) {
          this.value = newValue
          e.target.value = newValue
          toolbarElement.find('input[data-method=setAttribute]').click()
        } else {
          alert(this.invalidUrlMessage)
        }
      }
    })
  },
  methods: {
    repositionTrixToolbar() {
      var editor = this.$refs.editor.editor
      if (!editor) {
        this.toolbarElement.hide()
        return
      }

      var range = editor.getSelectedRange()
      if (range[0] === range[1]) {
        this.toolbarElement.hide()
        return
      }

      var selectionStartPosition = editor.getClientRectAtPosition(range[0])
      var selectionEndPosition = editor.getClientRectAtPosition(range[1]) || selectionStartPosition

      var virtualRectangle = {
        top: selectionStartPosition.top,
        left: Math.min(selectionStartPosition.left, selectionEndPosition.left),
        bottom: selectionEndPosition.top,
        right: Math.max(selectionStartPosition.left, selectionEndPosition.left),
      }

      var $postElement = $(this.$parent.$el)
      var anchorX
      if (virtualRectangle.top !== virtualRectangle.bottom) {
        anchorX = $postElement.offset().left + $postElement.width() / 2
      } else {
        anchorX = (virtualRectangle.left + virtualRectangle.right) / 2
      }

      var toolbarTargetFakeEvent = {
        preventDefault: true,
        pageX: anchorX,
        pageY: Math.max(virtualRectangle.top - 10, 0),
      }

      var isAndroid = device.android
      if (isAndroid) {
        this.toolbarElement.show().position({
          my: 'center bottom',
          at: 'center bottom',
          of: $(document),
          collision: 'fit flip',
        })
      } else {
        this.toolbarElement.show().position({
          my: 'center bottom',
          at: 'center top',
          of: toolbarTargetFakeEvent,
          collision: 'fit flip',
        })
      }
    },
    showTrixToolbar() {
      this.toolbarElement.show()
    },
    hideTrixToolbar() {
      this.toolbarElement.hide()
    },
    addCustomButtonsToToolbar() {
      // subscript and superscript
      let toolbarDomElement = this.toolbarElement[0]

      let buttonHTML =
        '<button type="button" class="trix-button trix-button--icon trix-button--icon-mark" data-trix-attribute="mark" title="Highlight">Highlight</button>'
      buttonHTML +=
        '<button type="button" class="trix-button trix-button--icon trix-button--icon-sup" data-trix-attribute="sup" title="Superscript">Superscript</button>'
      buttonHTML +=
        '<button type="button" class="trix-button trix-button--icon trix-button--icon-sub" data-trix-attribute="sub" title="Subscript">Subscript</button>'

      const buttonGroup = toolbarDomElement.querySelector('.trix-button-group--text-tools')
      buttonGroup.insertAdjacentHTML('beforeend', buttonHTML)

      // math
      buttonHTML =
        '<button type="button" class="trix-button trix-button--icon trix-button--icon-math" data-trix-attribute="math" title="Math">Math</button>'
      const codeButton = toolbarDomElement.querySelector('button[data-trix-attribute="code"]')
      codeButton.insertAdjacentHTML('afterend', buttonHTML)

      toolbarDomElement.classList.add('is-customized')
    },
  },
}
